import Component from '@glimmer/component';

export default class NwDeepResearchHistorySidebarComponent extends Component {
  // Trigger the update when the component arguments change
  get localResearchHistory() {
    return this.args.researchHistory;
  }
}
